export var HOUR = 'HOUR';
export var MINUTE = 'MINUTE';
export var AM = 'AM';
export var PM = 'PM';